export default {
  getCity: '/gateway/courier/cities/queryCitiesByParentId/list',
  submitCity: '/gateway/capp/mallcenter/userAddress/addOrUpdate'
}
